import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios'

class AddCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    // this.handleSubmitAuto = this.handleSubmitAuto.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  HandleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
    console.log(this.state)
  }
  handleSubmit = (e) => {
    e.preventDefault()
    console.log(this.state)
    console.log('Submitted')
    let c = axios.post(
      'https://backend1.riceinspections.com/testFD',
      { data: this.state }
    ).then(res => {
        console.log(res);
        this.props.history.push('/adminsys')
      })
  }


  render() {
    return (
      <Container>
        {/* {this.handleSubmitAuto()} */}
        <form onSubmit={this.handleSubmit}>
          <Link to="AdminSys">back</Link>
          <h1 id="label1">Add Company</h1>
          <label id="companyNameTH">Company Name(TH)</label>
          <input type="text" id="companyNameTH" className="inputText" placeholder="Company Name (TH)" onChange={this.HandleChange}></input>
          <label id="companyNameEN">Company Name(EN)</label>
          <input type="text" id="companyNameEN" className="inputText" placeholder="Company Name (EN)" onChange={this.HandleChange}></input>
          <label id="description">Description</label>
          <input type="text" id="description" className="inputDescription" placeholder="Description" onChange={this.HandleChange}></input>
          <Button variant="outline-success" id="addOffice" type="submit">Add</Button>
          <Button variant="danger" id="addOffice" onClick={this.props.history.goBack}>cancel</Button>

        </form>

      </Container>
    )
  }
}

export default AddCompany;
